import {
  DefaultError,
  useInfiniteQuery,
  useQuery,
} from "@tanstack/react-query";
import { useInfiniteHandler } from "hooks";
import { apiClient } from "utils";
import { getDefaultInfinitePageParam } from "utils/service/defaultInfinitePageParam";
import { useResponseHandler } from "utils/service/responseHandler";
import {
  IResponseSettlementPeriodsLightList,
  IResponsSettlementPeriods,
  ISettlementParams,
  ISettlementPeriods,
} from "./types";

export const useGetSettlementListInfinite = (params: ISettlementParams) => {
  const { responseHandler } = useResponseHandler();
  const { getNextPageParam, infiniteHandler } = useInfiniteHandler();

  const { itemCount: pageSize, page } = getDefaultInfinitePageParam(
    params.page,
    params.pageSize
  );

  return useInfiniteQuery<IResponsSettlementPeriods[], DefaultError>({
    queryKey: ["settlementPeriods", params],
    queryFn: async ({ pageParam }) => {
      const response = await apiClient({
        method: "GET",
        url: "SettlementPeriods",
        params: { ...params, pageSize, page: pageParam },
      });

      const value = await responseHandler<ISettlementPeriods>(response, {
        groupName: `useGetSettlementListInfinite - ${pageParam}`,
      });

      return infiniteHandler(value);
    },
    initialPageParam: page,
    getNextPageParam: getNextPageParam,
  });
};

export const useGetSettlementLightList = () => {
  const { responseHandler } = useResponseHandler();

  return useQuery<IResponseSettlementPeriodsLightList[], DefaultError>({
    queryKey: ["settlementPeriodsLightList"],
    async queryFn() {
      const response = await apiClient({
        method: "GET",
        url: "SettlementPeriods/LightList",
      });

      return responseHandler(response, {
        groupName: "useGetSettlementLightList",
      });
    },
  });
};
